export const ASSETS = {
  logoPilar: '/images/MARCA/LOGO-GRUPO-PILAR/LOGO-GRUPO-PILAR.png',
  logoDuraflow: '/images/MARCA/LOGO-DURAFLOW/LOGO-DURAFLOW.png',
  heroHome: '/images/HOME/HERO/HERO-HOME.webp',
  excelenciaHidraulica: '/images/HOME/EXCELENCIA/EXCELENCIA-HIDRAULICA-INDUSTRIAL.webp',
  oficina: '/images/HOME/OFICINA-ESPECIALIZADA/OFICINA-ESPECIALIZADA.webp',
  termovacuo: '/images/LOCACAO-EQUIPAMENTOS-INDUSTRIAIS/EQUIPAMENTOS/UNIDADE-TERMOVACUO-PILAR.webp',
  depoimentos01: '/images/HOME/DEPOIMENTOS/DEPOIMENTO-CLIENTE1.webp',
  depoimentos02: '/images/HOME/DEPOIMENTOS/DEPOIMENTO-CLIENTE2.webp',
  equipamentosIndustriais: '/images/EQUIPAMENTOS-E-COMPONENTES/venda-equipamentos.webp',
  comoPodemosAjudar01: '/images/HOME/OFICINA-ESPECIALIZADA/OFICINA-ESPECIALIZADA.webp',
  comoPodemosAjudar02: '/images/HOME/DURAFLOW/DURAFLOW.webp',
  comoPodemosAjudar03: '/images/HOME/SERVICOS-DE-CAMPO/SERVICOS-CAMPO.webp',
  comoPodemosAjudar04: '/images/HOME/LOCACAO-DE-EQUIPAMENTOS/LOCACAO.webp',
} as const;